import React from 'react';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const LocationSection = ({ 
  city, 
  country, 
  showAdvanced, 
  latitude, 
  longitude, 
  onCityChange, 
  onCountryChange, 
  onShowAdvancedChange,
  onLatitudeChange,
  onLongitudeChange,
  errors 
}) => {
  return (
    <div className="space-y-5 md:space-y-6">
      <div className="flex items-center space-x-3">
        <div className="w-1 h-8 bg-gradient-to-b from-secondary to-accent rounded-full" />
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground font-thai">
            สถานที่เกิด
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mt-1">
            Birth Location
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        <Input
          type="text"
          label="เมือง"
          placeholder="กรุงเทพมหานคร"
          value={city}
          onChange={(e) => onCityChange(e?.target?.value)}
          error={errors?.city}
          required
          description="City"
        />

        <Input
          type="text"
          label="ประเทศ"
          placeholder="ประเทศไทย"
          value={country}
          onChange={(e) => onCountryChange(e?.target?.value)}
          error={errors?.country}
          required
          description="Country"
        />
      </div>
      <Checkbox
        label="แสดงการตั้งค่าขั้นสูง"
        description="Show advanced coordinate settings"
        checked={showAdvanced}
        onChange={(e) => onShowAdvancedChange(e?.target?.checked)}
        className="mt-4"
      />
      {showAdvanced && (
        <div className="mt-5 p-5 md:p-7 bg-gradient-to-br from-muted/40 to-muted/20 backdrop-blur-sm border-2 border-border/50 rounded-xl space-y-5 md:space-y-6 transition-all duration-300">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary/20 rounded-lg flex items-center justify-center">
              <span className="text-primary text-sm">📍</span>
            </div>
            <div>
              <h4 className="text-sm md:text-base font-heading font-medium text-foreground font-thai">
                พิกัดทางภูมิศาสตร์
              </h4>
              <p className="text-xs text-muted-foreground">
                Geographic Coordinates (Optional for precise calculations)
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            <Input
              type="text"
              label="ละติจูด"
              placeholder="13.7563"
              value={latitude}
              onChange={(e) => onLatitudeChange(e?.target?.value)}
              description="Latitude (e.g., 13.7563 for Bangkok)"
            />

            <Input
              type="text"
              label="ลองจิจูด"
              placeholder="100.5018"
              value={longitude}
              onChange={(e) => onLongitudeChange(e?.target?.value)}
              description="Longitude (e.g., 100.5018 for Bangkok)"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationSection;